<template>
    <div class="d-flex cursor-pointer" @click="toggle">
        <div class="icon align-self-center">
            <i v-if="status" class="fa-regular fa-toggle-on text-success"></i>
            <i v-else class="fa-regular fa-toggle-off"></i>
        </div>
        <div class="ms-2 align-self-center text"><slot></slot></div>
    </div>
</template>

<script>
export default {
    props: ['label', 'status'],
    name: "toggle-btn",
    methods: {
        toggle(){
         //   this.$emit('toggle',!this.status)
        }
    }
}
</script>

<style scoped>
.icon{
    font-size: 2rem;
}
.text{
    font-size: 1.5rem;
}
</style>
